export const SET_USER = 'SET_USER';
export const RESET_USER = 'RESET_USER';
export const POLICY_LIST_STORE = 'POLICY_LIST_STORE';
export const POLICY_LIST_RESET = 'POLICY_LIST_RESET';
